import React from 'react';

const AIWorkflow: React.FC = () => {
  return (
    <div className="content-wrapper" role="main" aria-label="AI Workflow Diagram">
      <style>
        {`
        .diagram-container {
          max-width: 1000px;
          margin: 2rem auto;
          padding: 1rem;
          text-align: center;
        }
        .diagram-container svg {
          width: 100%;
          height: auto;
          display: block;
          margin: 0 auto;
        }
        .content-wrapper {
          padding: 2rem;
          background-color: #f8f9fa;
        }
        @media (max-width: 768px) {
          .diagram-container {
            padding: 0.5rem;
            margin: 1rem auto;
          }
          .content-wrapper {
            padding: 1rem;
          }
        }
        `}
      </style>
      <div className="diagram-container">
        <svg viewBox="0 0 800 600" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Sample Referral Workflow in ReferralCX">
          <defs>
            <linearGradient id="stepGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: '#667eea', stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: '#764ba2', stopOpacity: 1 }} />
            </linearGradient>
            <radialGradient id="aiGradient" cx="50%" cy="30%" r="70%">
              <stop offset="0%" style={{ stopColor: '#4facfe', stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: '#00f2fe', stopOpacity: 1 }} />
            </radialGradient>
            <linearGradient id="containerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: '#f8f9fa', stopOpacity: 1 }} />
            </linearGradient>
            <filter id="containerShadow" x="-20%" y="-20%" width="140%" height="140%">
              <feDropShadow dx="0" dy="8" stdDeviation="15" floodColor="#000000" floodOpacity="0.1" />
              <feDropShadow dx="0" dy="0" stdDeviation="25" floodColor="#667eea" floodOpacity="0.05" />
            </filter>
            <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: '#f8f9fa', stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: '#e9ecef', stopOpacity: 1 }} />
            </linearGradient>
            <filter id="dropShadow" x="-50%" y="-50%" width="200%" height="200%">
              <feDropShadow dx="2" dy="4" stdDeviation="3" floodOpacity="0.3" />
            </filter>
            <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur stdDeviation="4" result="coloredBlur" />
              <feMerge>
                <feMergeNode in="coloredBlur" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
            <marker id="arrowhead" markerWidth="12" markerHeight="10" refX="11" refY="5" orient="auto">
              <polygon points="0 0, 12 5, 0 10" fill="url(#stepGradient)" opacity="0.8" />
            </marker>
          </defs>

          <rect width="800" height="600" fill="url(#bgGradient)" />
          <rect x="20" y="20" width="760" height="560" rx="25" ry="25" fill="white" filter="url(#containerShadow)" opacity="0.95" />
          <rect x="25" y="25" width="750" height="550" rx="20" ry="20" fill="url(#containerGradient)" />

          <circle cx="120" cy="120" r="60" fill="#667eea" opacity="0.03" />
          <circle cx="680" cy="140" r="45" fill="#764ba2" opacity="0.03" />
          <circle cx="630" cy="470" r="70" fill="#4facfe" opacity="0.03" />

          <text x="400" y="55" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="28" fontWeight="bold" fill="#2c3e50">
            Sample Referral Workflow in ReferralCX
          </text>
          <text x="400" y="78" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="14" fill="#6c757d">
            AI-Powered Healthcare Referral Processing
          </text>

          <path d="M 180 200 L 470 200" stroke="#e9ecef" strokeWidth="4" opacity="0.5" />

          <circle cx="150" cy="200" r="32" fill="url(#stepGradient)" filter="url(#dropShadow)" />
          <circle cx="150" cy="200" r="25" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
          <text x="150" y="208" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="bold" fill="white">1</text>

          <text x="150" y="270" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="18" fontWeight="bold" fill="#2c3e50">
            Data Extraction
          </text>
          <text x="150" y="290" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="13" fill="#6c757d">
            AI extracts data from
          </text>
          <text x="150" y="308" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="13" fill="#6c757d">
            faxes and forms
          </text>

          <path d="M 190 200 L 250 200" stroke="url(#stepGradient)" strokeWidth="3" markerEnd="url(#arrowhead)" opacity="0.8" />

          <circle cx="400" cy="200" r="55" fill="url(#aiGradient)" filter="url(#dropShadow)" />
          <circle cx="400" cy="200" r="45" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2" />
          <circle cx="400" cy="200" r="35" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1" />
          <text x="400" y="218" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="38" fontWeight="bold" fill="white" filter="url(#glow)">AI</text>

          <path d="M 465 200 L 525 200" stroke="url(#stepGradient)" strokeWidth="3" markerEnd="url(#arrowhead)" opacity="0.8" />

          <circle cx="650" cy="200" r="32" fill="url(#stepGradient)" filter="url(#dropShadow)" />
          <circle cx="650" cy="200" r="25" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
          <text x="650" y="208" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="bold" fill="white">2</text>

          <text x="650" y="270" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="18" fontWeight="bold" fill="#2c3e50">
            Smart Routing
          </text>
          <text x="650" y="290" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="13" fill="#6c757d">
            Suggested routing &amp;
          </text>
          <text x="650" y="308" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="13" fill="#6c757d">
            urgency classification
          </text>

          <path d="M 400 260 Q 400 300 400 330" stroke="url(#stepGradient)" strokeWidth="3" markerEnd="url(#arrowhead)" opacity="0.8" fill="none" />

          <circle cx="400" cy="380" r="32" fill="url(#stepGradient)" filter="url(#dropShadow)" />
          <circle cx="400" cy="380" r="25" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
          <text x="400" y="388" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="20" fontWeight="bold" fill="white">3</text>

          <text x="400" y="450" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="18" fontWeight="bold" fill="#2c3e50">
            Action Planning
          </text>
          <text x="400" y="470" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="13" fill="#6c757d">
            Next-best actions &amp; comprehensive checklist
          </text>

          <rect x="60" y="485" width="180" height="75" rx="12" fill="white" stroke="url(#stepGradient)" strokeWidth="2" filter="url(#dropShadow)" opacity="0.95" />
          <text x="150" y="503" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="13" fontWeight="bold" fill="#2c3e50">Automated Processing</text>
          <text x="150" y="520" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="10" fill="#6c757d">Instantly processes multiple</text>
          <text x="150" y="533" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="10" fill="#6c757d">document types with accuracy</text>
          <text x="150" y="546" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="10" fill="#6c757d">and speed</text>

          <rect x="310" y="485" width="180" height="75" rx="12" fill="white" stroke="url(#stepGradient)" strokeWidth="2" filter="url(#dropShadow)" opacity="0.95" />
          <text x="400" y="503" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="13" fontWeight="bold" fill="#2c3e50">Intelligent Routing</text>
          <text x="400" y="520" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="10" fill="#6c757d">Smart assignment based on</text>
          <text x="400" y="533" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="10" fill="#6c757d">urgency levels and specialist</text>
          <text x="400" y="546" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="10" fill="#6c757d">availability</text>

          <rect x="560" y="485" width="180" height="75" rx="12" fill="white" stroke="url(#stepGradient)" strokeWidth="2" filter="url(#dropShadow)" opacity="0.95" />
          <text x="650" y="503" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="13" fontWeight="bold" fill="#2c3e50">Action Management</text>
          <text x="650" y="520" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="10" fill="#6c757d">Comprehensive checklists</text>
          <text x="650" y="533" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="10" fill="#6c757d">ensure nothing falls through</text>
          <text x="650" y="546" textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="10" fill="#6c757d">the cracks</text>
        </svg>
      </div>
    </div>
  );
};

export default AIWorkflow;
